export const getContent = (props) => {
    let content = null;
    if (props.children != null)
        content = props.children;
    if (props.content != null)
        content = props.content;
    return content;
};
//# sourceMappingURL=getContent.js.map